import axios from "@/api/config_php";

export const searchOptions = param =>
  axios.post("/amp/api/v1/config/datas", param);
//获取行业
export const getIndustry = param =>
  axios.post("/amp/api/v1/getIndustry", param);
//获取地址省市
export const getCompanyAddress = param =>
  axios.post("/amp/api/v1/getCompanyAddress", param);

//获取企业信息
export const getClientCompany = param =>
  axios.get("/amp/api/v1/client/getClientCompany", { params: param });

//修改企业信息
export const updateClientCompany = param =>
  axios.post("/amp/api/v1/client/updateClientCompany", param);

//提取营业执照信息
export const getCompanyLicenseLinkInfo = param =>
  axios.post("/amp/api/v1/client/ocrBusinessLicense", param);

//修改企业信息
export const getCompanyStatus = param =>
  axios.post("/amp/api/v1/client/getClientStatus", param);

//我的报表
export const getReportForms = param =>
  axios.get("/amp/api/v1/taskcore/lists", { params: param });

//获取更新时间
export const getReportFormsUpdateTime = param =>
  axios.post("/amp/api/v1/taskcore/getClosingDate", param);

//创建报表
export const creatReportForms = param =>
  axios.post("/amp/api/v1/taskcore/generateStatisticsAccount", param);

//获取报表下载进度
export const getFormsDownloadProcess = param =>
  axios.get("/amp/api/v1/taskcore/getProgress", { params: param });

//重新生成
export const rebuildReportForms = param =>
  axios.post("/amp/api/v1/taskcore/retry", param);

//删除下载任务
export const deleteReportForms = param =>
  axios.post("/amp/api/v1/taskcore/delTask", param);

export const getSysNotice = param =>
  axios.post("/amp/api/v1/systemNotice/getNotice", {});

// 余额调整记录 导出
export const generateRecharge = param =>
  axios.post(`/amp/api/v1/taskcore/generateRecharge`, param);

// 首页获取媒体消耗-环比
export const getRelativeRatio = param =>
  axios.post(`/amp/api/v1/statistics/getRelativeRatio`, param);

//获取广告位上'进行中'的广告
export const getAds = param =>
  axios.get("/amp/api/v1/platformAds/getAds", { params: param });

// 广告“浏览/点击”上报接口
export const adsCollect = param =>
  axios.post(`/amp/api/v1/platformAds/collect`, param);

// 获取可领优惠券的开户公司
export const getCouponAccountCompany = param =>
  axios.get(`/amp/api/v1/ActivityFbMarket/getAccountCompany`, {
    params: param
  });

// 获取广告账户
export const getCouponAccounts = param =>
  axios.get(`/amp/api/v1/ActivityFbMarket/getAccount`, { params: param });

// 领取优惠券
export const claimCoupons = param =>
  axios.post(`/amp/api/v1/ActivityFbMarket/claimCoupons`, param);

//开户申请列表导出
export const openAccountExport = param =>
  axios.post(`/amp/api/v1/taskcore/exportAccountOpen`, param);

export const getCodeImage = param =>
  axios.get("/amp/api/v1/miniprogram/getQrcodeImage", { params: param });
